import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormError',
  props: {
    errors: null,
    field: null
  },
  setup(__props: any) {

const props = __props as {
  errors: Record<string, string[]> | null
  field: string
};



const errorClass = computed(() => {
  return 'error-' + props.field
})

const hasError = computed(() => {
  if (!props.errors) {
    return false
  }
  const errors = props.errors[props.field]
  return errors && errors.length > 0
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["invalid-feedback", _unref(errorClass)]),
    style: _normalizeStyle(_unref(hasError) ? { display: 'block' } : {})
  }, [
    (__props.errors && __props.errors[__props.field])
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors[__props.field], (error, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              innerHTML: error
            }, null, 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})